import { Stack, Typography, CircularProgress, useTheme, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UserLessonStatistics } from "models/UserLessonStatistics";
import { RewardType } from "models/RewardType";
import { StatisticsTitle, RewardsTitle, StyledDivider } from './YourStatisticsSection.styles';
import { useMemo } from "react";

export const YourStatisticsSection = (props: { statistics: UserLessonStatistics, getStatisticsPending: boolean, isStatisticOfLoggedUser: boolean }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { statistics, getStatisticsPending, isStatisticOfLoggedUser } = props;

    const rewardCounts = useMemo(() => {
        const counts: Record<RewardType, number> = {
            [RewardType.Gold]: 0,
            [RewardType.Silver]: 0,
            [RewardType.Bronze]: 0,
            [RewardType.None]: 0,
        };

        for (const progress of statistics.actualProgresses) {
            if (progress.rewardType in counts) {
                counts[progress.rewardType] += 1;
            }
        }

        return counts;
    }, [statistics.actualProgresses]);

    return getStatisticsPending
            ? <CircularProgress />
            : <Stack direction='row' alignItems='stretch' spacing={theme.spacing(2)} paddingTop={theme.spacing(4)} paddingBottom={theme.spacing(4)} width='100%'>
                <Stack direction='column' alignItems='center' spacing={theme.spacing(4)} width='50%'>
                    <StatisticsTitle variant="h5" width={'100%'} textAlign={'left'}>
                        {isStatisticOfLoggedUser ? t('myTrainings.yourStatistics') : t('myTrainings.userStatistics')}
                    </StatisticsTitle>
                    <Grid container spacing={theme.spacing(1)} paddingLeft={theme.spacing(2)}>
                        <Grid item xs={9}>
                            <Typography variant="subtitle1" component="div">{t('myTrainings.numberOfTrainingsAssaignedToUser')}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle1" component="div">{statistics.lessonsCount}</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography variant="subtitle1" component="div">{t('myTrainings.allLessonsProgress')}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle1" component="div">{statistics.allLessonsProgress + '%'}</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography variant="subtitle1" component="div">{t('myTrainings.sumOfPointsScored')}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle1" component="div">{statistics.sumOfPointsScored + ' / ' + statistics.sumOfMaxPoints}</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography variant="subtitle1" component="div">{t('myTrainings.placeInOrganizationRanking')}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle1" component="div">{statistics.placeInOrganizationRanking + ' / ' + statistics.organizationParticipantsCount}</Typography>
                        </Grid>                        
                    </Grid>
                </Stack>
                <StyledDivider orientation="vertical" flexItem />
                <Stack direction='column' alignItems='center' textAlign={'left'} spacing={theme.spacing(4)} width='50%'>
                    <RewardsTitle variant="h5" width={'100%'}>
                        {isStatisticOfLoggedUser ? t('myTrainings.yourRewards') : t('myTrainings.userRewards')}                        
                    </RewardsTitle>
                    <Grid container spacing={theme.spacing(1)} paddingLeft={theme.spacing(2)}>
                        <Grid item xs={4}>
                            <Typography variant="subtitle1" component="div">{t('rewardType.gold')}</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="subtitle1" component="div">{rewardCounts[RewardType.Gold]}</Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography variant="subtitle1" component="div">{t('rewardType.silver')}</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="subtitle1" component="div">{rewardCounts[RewardType.Silver]}</Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography variant="subtitle1" component="div">{t('rewardType.bronze')}</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="subtitle1" component="div">{rewardCounts[RewardType.Bronze]}</Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography variant="subtitle1" component="div">{t('rewardType.none')}</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="subtitle1" component="div">{rewardCounts[RewardType.None]}</Typography>
                        </Grid>
                    </Grid>
                </Stack>
            </Stack>
}
